module.exports = __webpack_public_path__ + "static/certificate-7c2df503bf9044a62eadb7eef08cbd12.webp";